import Joi from '@hapi/joi'

export const SummeryReportSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group cannot have invalid characters`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Operatin Entity cannot have invalid characters`,
        "any.required": `Operatin Entity required`
    }),
    fromDate: Joi.string().invalid("").label("From Date"),
    toDate: Joi.string().invalid("").label("To Date"),
    collectionCategoryID: Joi.number().invalid(0).required().label("Collectioncatagory").messages({
        "string.empty": `Collectioncatagory required`,
        "string.pattern.base": `Please enter valid Collectioncatagory`,
    }),
    collectionPointID: Joi.number().required().label("Collectionpoint").messages({
        "any.invalid": `Collectionpoint cannot have invalid characters`,
        "any.required": `Collectionpoint required`
    }),
}